<template>
  <div>
    <text-input
      id="role-name"
      name="Name"
      rules="required|min:3|max:250"
      :text.sync="role.displayName"
    />

    <permissions-inputs
      :grouped-permissions="groupedPermissions"
      :selected-permissions.sync="role.permissions"
    />
  </div>
</template>

<script>
import TextInput from '@/components/FormInputs/TextInput.vue'
import PermissionsInputs from '../Permissions/PermissionsInputs.vue'

export default {
  name: 'RoleInputs',
  components: { TextInput, PermissionsInputs },
  props: {
    role: { type: Object, default: () => {} },
    groupedPermissions: { type: Array, default: () => [] },
  },
}
</script>

<style>

</style>
